import { createApp } from 'vue'
import App from './App.vue'

// Element
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Design system base styles (nueva capa de estilos)
import '@/assets/styles/foundations/ds-fonts.css';
import '@/assets/styles/foundations/ds-tokens.css';
import '@/assets/styles/foundations/ds-typography.css';
import '@/assets/styles/shared/ds-utilities.css';
import '@/assets/styles/shared/ds-elements-overrides.css';

// import locale from 'element-ui/lib/locale/lang/en'
import locale from 'element-plus/es/locale/lang/es'

import router from './router';
import i18n from '@/plugins/i18n';
import store from './store'

// Importa los filtros como funciones puras desde utils
import { formatDate, formatPrice, descarteNulo, defaultEmpty } from '@/utils/filters'

const app = createApp(App)

// Registra los filtros como propiedades globales individuales
app.config.globalProperties.$formatDate = formatDate
app.config.globalProperties.$formatPrice = formatPrice
app.config.globalProperties.$descarteNulo = descarteNulo
app.config.globalProperties.$defaultEmpty = defaultEmpty
// Mantiene $filters para compatibilidad con componentes existentes
app.config.globalProperties.$filters = { formatDate, formatPrice, descarteNulo, defaultEmpty }

// Registrar todos los iconos de Element Plus globalmente
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.use(store)
app.use(i18n)
app.use(ElementPlus, { locale })

// Evita el overlay de runtime para 401 esperados (sesion expirada/no autenticada)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event && event.reason
  const status = reason && reason.response && reason.response.status

  if (status === 401) {
    store.commit('sesion/setSesionExpirada', true)
    event.preventDefault()
  }
})

// agrego un interceptor para el manejo de errores
import { garantia, clientePedido } from './apiClient/index'
import { mostrarMensajeInternacionalizado } from './components/MensajeInternacionalizado'

garantia.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const status = error && error.response && error.response.status
    
  // si se produjo un error de autenticación, redirijo al login
  if(status === 401)
  {
    store.commit('sesion/setSesionExpirada', true)
  }

  // si se produjo un error de autorización, muestro una alerta
  if(status === 403)
  {
    mostrarMensajeInternacionalizado('UNAUTHORIZED')
  }

  return Promise.reject(error)
});

app.mount('#app')

clientePedido.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const status = error && error.response && error.response.status
    
  // si se produjo un error de autenticación, redirijo al login
  if(status === 401)
  {
    store.commit('sesion/setSesionExpirada', true)
  }

  // si se produjo un error de autorización, muestro una alerta
  if(status === 403)
  {
    mostrarMensajeInternacionalizado('UNAUTHORIZED')
  }

  return Promise.reject(error)
});